module.exports = "/_next/static/images/build-57a44e726bf18f966972b486af62e12f.png";